import o from "./index440.js";
import { createBlock as a, openBlock as t, resolveDynamicComponent as n, normalizeClass as s, withCtx as p, renderSlot as d } from "vue";
import l from "./index231.js";
function r(e, i, m, f, y, H) {
  return t(), a(n(e.getTag()), {
    class: s({
      "text-h4": e.type === e.MsHeadlineType.H4,
      "text-h3": e.type === e.MsHeadlineType.H3,
      "text-h2": e.type === e.MsHeadlineType.H2,
      "text-h1": e.type === e.MsHeadlineType.H1,
      "font-bold-headline": e.isBold
    }),
    "data-component": e.$options.name,
    "data-mod": e.type
  }, {
    default: p(() => [
      d(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["class", "data-component", "data-mod"]);
}
const M = /* @__PURE__ */ l(o, [["render", r]]);
export {
  M as default
};
